/* STEP 11d-7 · lane D7b (owner answers, 01-Nov-2026 18:31 KSA) — EN + AR of
   item 2 the restatement Emphasis of Matter: the decline reason is required (RestatementEomSuggest; the server code
          RESTATEMENT_EOM_DECLINE_REASON_REQUIRED);
   item 3 the associate investment's unexplained increase on a trial-balance cash flow (IFRSCashFlowTbInputs; the gap itself
          is named by the server).
   Item 4 (the SME names) is server text (fs_head_names_sme.py). No standard paragraph is quoted. */
const I18N_S11D7B = {
  en: {
    s11d7b: {
      eom: {
        declinePrompt: "Decline the Emphasis of Matter for the restatement? Give the reason (required). It goes on the Audit Trail and shows next to the decline.",
        reasonPlaceholder: "Reason for declining",
        reasonRequired: "Give the reason for declining the Emphasis of Matter for the restatement.",
      },
      assoc: {
        purchaseHint: "The investment in associates rose by more than the share of profit and the figures entered explain: enter the cash paid for the purchase of / investment in associates.",
      },
    },
    errors: {
      RESTATEMENT_EOM_DECLINE_REASON_REQUIRED: "Give the reason for declining the Emphasis of Matter for the restatement.",
    },
    // the Audit Trail rows of the decline (the reason shows beside the entity) and of "Offer again"
    w13: {
      action: {
        restatement_eom_declined: "Restatement Emphasis of Matter declined",
        restatement_eom_offered_again: "Restatement Emphasis of Matter offered again",
      },
      entity: { auditor_report: "Auditor's report" },
    },
  },
  ar: {
    s11d7b: {
      eom: {
        declinePrompt: "رفض فقرة لفت الانتباه الخاصة بإعادة العرض؟ اذكر السبب (مطلوب). يُسجَّل في سجل التدقيق ويظهر بجانب الرفض.",
        reasonPlaceholder: "سبب الرفض",
        reasonRequired: "اذكر سبب رفض فقرة لفت الانتباه الخاصة بإعادة العرض.",
      },
      assoc: {
        purchaseHint: "ارتفع الاستثمار في الشركات الزميلة بأكثر مما تفسّره الحصة من الأرباح والأرقام المدخلة: أدخل النقد المدفوع لشراء / الاستثمار في شركات زميلة.",
      },
    },
    errors: {
      RESTATEMENT_EOM_DECLINE_REASON_REQUIRED: "اذكر سبب رفض فقرة لفت الانتباه الخاصة بإعادة العرض.",
    },
    w13: {
      action: {
        restatement_eom_declined: "رفض فقرة لفت الانتباه الخاصة بإعادة العرض",
        restatement_eom_offered_again: "اقتراح فقرة لفت الانتباه الخاصة بإعادة العرض مجددًا",
      },
      entity: { auditor_report: "تقرير المراجع" },
    },
  },
};

export default I18N_S11D7B;
